import { Debugger } from 'springroll';
import { GA_TRACKING_CATEGORY } from '../app/constants/AppConstants';

/**
 * Singleton bridge for google analytics tracking
 *
 * https://projects.pbs.org/bitbucket/projects/SD/repos/springroll-google-analytics/
 *
 */

let instance = null;

class GoogleAnalytics {
  constructor(plugin) {
    if (instance) {
      return instance;
    }
    instance = this;
    Debugger.log('log', 'GoogleAnalytics plugin registered', plugin);
    this._plugin = plugin;

    this.category = GA_TRACKING_CATEGORY;
    this.label = '';

    return instance;
  }

  destroy() {
    instance = null;
    this._plugin = null;
  }

  setLabel(label) {
    this.label = label;
  }

  track({ category = this.category, action = '', label = this.label, value = '' }) {
    Debugger.log('log', 'GoogleAnalytics.track', category, action, label, value);
    this._plugin && this._plugin.event(category, action, label, value);
  }
}

export function getGA(plugin) {
  return new GoogleAnalytics(plugin);
}

export function addGoogleAnalyticsPlugin({ plugin }) {
  return new GoogleAnalytics(plugin);
}
